module.exports = __webpack_public_path__ + "static/media/动物头像生成.09b6cea8.png";